import { Instant, ZonedDateTime, ZoneId, ZoneOffset } from '@js-joda/core'
import { fromZonedDateTime } from '@migrate/utils/date/index'
import { stores } from '@migrate/stores'
import { LocalesStore } from '@migrate/stores/LocalesStore'

export default class InstantConverter {
  public zonedDateTimeFromEpochSecond(value: number): ZonedDateTime {
    return ZonedDateTime.ofInstant(Instant.ofEpochSecond(value), ZoneOffset.UTC)
  }

  public zonedDateTimeFromEpochMilli(value: number): ZonedDateTime {
    return ZonedDateTime.ofInstant(Instant.ofEpochMilli(value), ZoneOffset.UTC)
  }

  public systemZonedDateTimeFromEpochMilli(value: number): ZonedDateTime {
    return ZonedDateTime.ofInstant(Instant.ofEpochMilli(value), ZoneOffset.UTC).withZoneSameInstant(
      ZoneId.SYSTEM,
    )
  }

  public localized(value: Instant): string {
    const { locale } = stores[LocalesStore.STORE_NAME]
    return fromZonedDateTime(ZonedDateTime.ofInstant(value, ZoneOffset.UTC)).toLocalizedString(
      locale,
    )
  }

  public localizedFromEpochSecond(value: number): string {
    const { locale } = stores[LocalesStore.STORE_NAME]
    return fromZonedDateTime(this.zonedDateTimeFromEpochSecond(value)).toLocalizedString(locale)
  }

  public localizedFromEpochMilli(value: number): string {
    const { locale } = stores[LocalesStore.STORE_NAME]
    return fromZonedDateTime(this.zonedDateTimeFromEpochMilli(value)).toLocalizedString(locale)
  }
}
